import { useQuery } from '@tanstack/react-query'

import { findCustomers } from './api/api'
import { customersSearchKey } from './keyFactory'

// Search is disabled while the (already-debounced) query is empty, so the home
// screen makes no request until the operator types — matching the mobile
// useSearchCustomers behavior.
export function useSearchCustomers(query: string) {
  return useQuery({
    queryKey: customersSearchKey(query),
    queryFn: () => findCustomers(query),
    enabled: query.length > 0,
  })
}
